import React, {useEffect, useState} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import './Css/SeeAll.css';
import CompanyInfoChip from "../Components/CompanyInfoChip";
import icon_search from "../Image/icon_search.png";
import RoomTab from "../Components/RoomTab";
import ViewAllComponent from "../Components/ViewAllComponent";
import deletebtn from "../Image/deletebtn.png";
import retouch from "../Image/retouch.png";
import RoomTabs from "../Components/RoomTab";
import axios from "axios";
import config from "../ip.json";
import CompanyCardList from "../Components/CompanyCardList";
import CompanyCardListinRoomNumber from "../Components/CompanyCardListinRoomNumber";

const SeeAll = ({companyDataArr,onClose}) => {
    const companyArr = ["루티", "바이낸스", "수민기업", "민제산업", "동근기업", "아크", "(주)배고픈형제들", "아부다비", "클론라프란", "비고라비", "동근당근", "람주", "술사랑기업", "라씨", "애플", "삼성전자", "엘지산업", "마이크로소프트", "테슬라", "배달의깐족"]
    const location = useLocation();
    const navigate = useNavigate();
    const [dataListArr, setDataListArr] = useState([]); // 모달의 상태를 관리

    const dataList = dataListArr.map(item => item);

    // 초기값: state에서 받거나 기본값 설정
    const [companyData, setCompanyData] = useState(companyDataArr);

    const [selectedRoom, setSelectedRoom] = useState(null); // 선택된 호실 상태 추가
    const [filteredData, setFilteredData] = useState([]); // 필터링된 데이터를 상태로 관리



    const handleRoomSelect = (room) => {
        setSelectedRoom(room); // 선택된 호실 업데이트
        setFilteredData([]); // 이전 데이터를 초기화
        setTimeout(() => {
            // 선택된 데이터만 필터링 후 상태 업데이트
            const filtered = dataList.filter(
                (item) => item.room_number === String(String(room).split('호')[0])
            );
            setFilteredData(filtered);
            console.log(filteredData)
        }, 0); // 비동기적 렌더링 처리
    };


    const handleBackClick = () => {
        onClose()
    };
    const getList = async (companyName) => {
        const jwtToken = sessionStorage.getItem("Authorization");

        try {
            // const queryParam = "test_company"; // 보내야 할 문자열
            const response = await axios.get(config.url + "/v2/payment/company", {

                params: {
                    name: companyName, // 쿼리 파라미터로 보낼 데이터
                },
                headers: {
                    Authorization: jwtToken,
                    "Content-Type": "application/json",
                },
                withCredentials: true, // 쿠키 필요 시 설정
            });

            console.log(response.data); // 콘솔로 데이터 확인
            console.log(config.url);
            setDataListArr(response.data); // 데이터 배열을 상태로 설정

        } catch (error) {
            console.error("Error fetching data:", error);
            alert("데이터를 가져오는 중 문제가 발생했습니다.===========");
        }
    };
    useEffect(() => {
        getList(companyData.company); // companyData.company가 변경될 때마다 실행

    }, []);



    return (

        <div className="registration-container">
            <div className="registration-middle-container">
                <div className={'blur'}></div>

                {/* 사이드바 */}
                <div className="registration-sidebar">
                    <div className="search">
                        <img className="icon_search" src={icon_search} alt="See more"/>
                        <input className="search-bar" placeholder="업체명을 입력하세요"/>
                    </div>
                    {/* Chip 컴포넌트 */}
                    {companyArr.map((chipName) => (
                        <CompanyInfoChip key={chipName} name={chipName}/>
                    ))}
                </div>

                {/* 메인 박스 */}
                <div className="see-all-mainbox">
                    <div className="view-all-back-btn" onClick={handleBackClick}>
                        뒤로가기
                    </div>
                    <div className="see-all-mainbox-left">
                        {/* 회사 정보 박스 */}
                        <div className="view-all-company-titlebox">

                            <div className="payment-company-name">{companyData.company}</div>

                            <div className="payment-company-info-box">
                                <div className="payment-company-info-innerbox">
                                    <div className="payment-info-cap">대표자 : {companyData.boss}</div>
                                    <div className="payment-info-use-room"> 입주
                                        호실: {companyData.rooms.map((room) => `${room}호`).join(', ')}
                                    </div>
                                </div>
                                <div className="payment-info-box">
                                    <div className="payment-info"> 보증금:
                                        ₩ {new Intl.NumberFormat('ko-KR').format(companyData.deposit)}
                                    </div>
                                    <div className="payment-info-1">사업자번호 : {companyData.certificate_registration}</div>
                                    <div className="payment-info-1">전화번호 : {companyData.phone}</div>
                                </div>
                            </div>
                        </div>
                        <div className="view-all-text">전체내역</div>
                        <div className="see-all-box">
                            <RoomTabs
                                rooms={companyData.rooms}
                                onSelect={handleRoomSelect}
                                selectedRoom={selectedRoom}
                            />

                            {filteredData
                                .filter((data) => data.room_number === selectedRoom) // 필터링 조건
                                .slice() // 원본 데이터 보호 (dataList를 복사)
                                .sort((a, b) => new Date(b.create_time) - new Date(a.create_time)) // 내림차순 정렬
                                .map((filteredRoom, index) => (
                                    <CompanyCardListinRoomNumber
                                        key={filteredRoom.id} // 유니크한 키 필요
                                        id={filteredRoom.id}
                                        years={filteredRoom.create_time}
                                        surtax={filteredRoom.surtax}
                                        rental={filteredRoom.rent}
                                        electricityBill={filteredRoom.elec_bill}
                                        gasBill={filteredRoom.gas_bill}
                                        isRental={filteredRoom.res_rent}
                                        isElectricityBill={filteredRoom.res_elec}
                                        isGasBill={filteredRoom.res_gas}
                                        isSurtax={filteredRoom.res_surtax}
                                        room_number={filteredRoom.room_number}
                                        total_amount={filteredRoom.total_amount}
                                    />
                                ))}

                        </div>
                        <div className={'a'}>.sfddsfdfds</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SeeAll;
